import { api } from "@api/api";
import { TiledeskStatus } from "@modules/tiledesk/types";

export async function getTiledeskStatusService(
  agreementId: string
): Promise<TiledeskStatus> {
  const { data } = await api.get<TiledeskStatus>(
    `v1/tiledesk/agreements/${agreementId}/status/`
  );
  return data;
}
